import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import UserContext from "../../context/user";

const useCheckUpDeleteMutation = () => {
  const { callApi, userProfile } = useContext(UserContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ request }) =>
      callApi(`/checkUp/request/${request?.id}`, {
        method: "DELETE",
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
      },
    }
  );
};

export default useCheckUpDeleteMutation;
